/**
 * Shared fallback image when product/image URL is missing.
 * Use a local asset (e.g. public/placeholder-image.jpg) in production if preferred.
 */
export const PLACEHOLDER_IMAGE = 'https://images.unsplash.com/photo-1445205170230-053b83016050?w=800&q=80';
